import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MakeAvatar } from './mixins';
const Avatar = styled.img `
  ${props => MakeAvatar(props)}
`;
export const AvatarUser = ({ src, size }) => {
    return React.createElement(Avatar, { src: src, size: size });
};
AvatarUser.propTypes = {
    src: PropTypes.string.isRequired,
    size: PropTypes.number,
};
AvatarUser.defaultProps = {
    size: 44,
};
